(() => {
  const body = document.body;
  const overlay = document.querySelector('[data-drawer-overlay]');
  const toast = document.querySelector('[data-toast]');

  const money = (cents) => {
    const value = (Number(cents || 0) / 100).toFixed(2);
    return (window.qissa?.moneyFormat || 'Rs. {{amount}}').replace('{{amount}}', value).replace('{{ amount }}', value);
  };

  const showToast = (message) => {
    if (!toast) return;
    toast.textContent = message;
    toast.classList.add('is-visible');
    clearTimeout(showToast.timer);
    showToast.timer = setTimeout(() => toast.classList.remove('is-visible'), 2600);
  };

  const closeDrawers = () => {
    document.querySelectorAll('.drawer.is-open').forEach((drawer) => {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
    });
    document.querySelectorAll('.facets.is-open').forEach((el) => el.classList.remove('is-open'));
    if (overlay) overlay.hidden = true;
    body.classList.remove('drawer-open');
  };

  const openDrawer = (selector) => {
    const drawer = document.querySelector(selector);
    if (!drawer) return;
    closeDrawers();
    drawer.classList.add('is-open');
    drawer.setAttribute('aria-hidden', 'false');
    if (overlay) overlay.hidden = false;
    body.classList.add('drawer-open');
    drawer.querySelector('button, a, input, select')?.focus();
  };

  document.addEventListener('click', (event) => {
    const opener = event.target.closest('[data-open-drawer]');
    if (opener) {
      event.preventDefault();
      openDrawer(opener.dataset.openDrawer);
      return;
    }
    if (event.target.closest('[data-close-drawer]') || event.target === overlay) closeDrawers();
    const filterOpen = event.target.closest('[data-open-filters]');
    if (filterOpen) {
      document.querySelector('[data-facets]')?.classList.add('is-open');
      if (overlay) overlay.hidden = false;
      body.classList.add('drawer-open');
    }
  });

  document.addEventListener('keydown', (event) => { if (event.key === 'Escape') closeDrawers(); });

  const header = document.querySelector('[data-site-header]');
  if (header?.classList.contains('is-transparent')) {
    const updateHeader = () => header.classList.toggle('is-scrolled', window.scrollY > 40);
    updateHeader();
    window.addEventListener('scroll', updateHeader, { passive: true });
  }

  const refreshCart = async (open = true) => {
    const headerSection = document.querySelector('[data-header-section]');
    if (!headerSection) return;
    const sectionId = headerSection.dataset.headerSection;
    const response = await fetch(`${window.qissa.routes.cart}?section_id=${encodeURIComponent(sectionId)}`);
    if (!response.ok) throw new Error('Unable to refresh cart');
    const html = await response.text();
    const doc = new DOMParser().parseFromString(html, 'text/html');
    const incoming = doc.querySelector('[data-cart-drawer-inner]');
    const current = document.querySelector('[data-cart-drawer-inner]');
    if (incoming && current) current.replaceWith(incoming);
    const incomingCount = doc.querySelector('[data-cart-count]');
    document.querySelectorAll('[data-cart-count]').forEach((el) => {
      el.textContent = incomingCount?.textContent || '0';
    });
    if (open) openDrawer('#CartDrawer');
  };

  document.addEventListener('submit', async (event) => {
    const form = event.target.closest('[data-ajax-product-form]');
    if (!form) return;
    event.preventDefault();
    const submit = form.querySelector('[type="submit"]');
    submit?.setAttribute('aria-busy', 'true');
    submit && (submit.disabled = true);
    try {
      const response = await fetch(`${window.qissa.routes.cartAdd}.js`, {
        method: 'POST',
        headers: { 'Accept': 'application/json' },
        body: new FormData(form)
      });
      const result = await response.json();
      if (!response.ok) throw new Error(result.description || 'Could not add this item.');
      await refreshCart(true);
      showToast('Added to your story bag.');
    } catch (error) {
      showToast(error.message);
    } finally {
      submit?.removeAttribute('aria-busy');
      submit && (submit.disabled = false);
    }
  });

  document.addEventListener('click', async (event) => {
    const qtyButton = event.target.closest('[data-cart-quantity]');
    const removeButton = event.target.closest('[data-cart-remove]');
    if (!qtyButton && !removeButton) return;
    event.preventDefault();
    const key = (qtyButton || removeButton).dataset.key;
    const input = document.querySelector(`[data-cart-input="${CSS.escape(key)}"]`);
    let quantity = removeButton ? 0 : Math.max(0, Number(input?.value || 0) + Number(qtyButton.dataset.cartQuantity || 0));
    try {
      const response = await fetch(`${window.qissa.routes.cartChange}.js`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
        body: JSON.stringify({ id: key, quantity })
      });
      if (!response.ok) throw new Error('Cart could not be updated.');
      await refreshCart(false);
    } catch (error) { showToast(error.message); }
  });

  document.addEventListener('change', (event) => {
    const variantSelect = event.target.closest('[data-variant-select]');
    if (!variantSelect) return;
    const form = variantSelect.closest('[data-product-root]');
    const option = variantSelect.options[variantSelect.selectedIndex];
    const idInput = form?.querySelector('[name="id"]');
    if (idInput) idInput.value = option.value;
    const price = form?.querySelector('[data-product-price]');
    const compare = form?.querySelector('[data-product-compare]');
    const button = form?.querySelector('[data-product-submit]');
    const status = form?.querySelector('[data-product-status]');
    const available = option.dataset.available === 'true';
    if (price) price.textContent = money(option.dataset.price);
    if (compare) {
      compare.textContent = Number(option.dataset.compare || 0) > Number(option.dataset.price || 0) ? money(option.dataset.compare) : '';
      compare.hidden = !compare.textContent;
    }
    if (button) {
      button.disabled = !available;
      button.querySelector('span').textContent = available ? button.dataset.addText : button.dataset.soldText;
    }
    if (status) {
      status.textContent = available ? 'In stock — ready to order' : 'Currently sold out';
      status.dataset.status = available ? 'available' : 'soldout';
    }
    if (history.replaceState && option.dataset.url) history.replaceState({}, '', option.dataset.url);
  });

  document.querySelectorAll('[data-sort-select]').forEach((select) => {
    select.addEventListener('change', () => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', select.value);
      window.location.href = url.toString();
    });
  });
  document.querySelectorAll('[data-product-recommendations]').forEach(async (section) => {
    try {
      const response = await fetch(section.dataset.url);
      if (!response.ok) return;
      const html = await response.text();
      const doc = new DOMParser().parseFromString(html, 'text/html');
      const incoming = doc.querySelector('[data-recommendations-inner]');
      const current = section.querySelector('[data-recommendations-inner]');
      if (incoming && current && incoming.innerHTML.trim()) current.replaceWith(incoming);
      else section.hidden = true;
    } catch (_) { section.hidden = true; }
  });

})();
